import { render, staticRenderFns } from "./GofixCasesContainer.vue?vue&type=template&id=1d67436d&"
import script from "./GofixCasesContainer.vue?vue&type=script&lang=js&"
export * from "./GofixCasesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports